import { Component, OnInit } from '@angular/core';
import { RegisterParking, Address, Scheduler, Tariff, RegisterTariff, RegisterParkingLot } from '../../entity';
import Enums from '../../utils/enums';
import { SettingsService, AuthService } from '../../service';
import { IDropdown } from '../../interfaces';
import { AddLotService } from '../../service/main/add-lot.service';
import { ToastrService } from '../../service/common/toastr.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-parking-add',
    templateUrl: './parking-add.component.html'
})
export class ParkingAddComponent implements OnInit {
    parking: RegisterParking = new RegisterParking();
    currentTariff: RegisterTariff;
    currentLotGeneration: RegisterParkingLot;
    id = 0;
    user: any;
    loading: boolean;

    days: Array<number> = [null, 1, 2, 3, 4, 5, 6, 7];
    parkingTypes: IDropdown[];
    parkingLevelTypes: IDropdown[];
    currencyTypes: IDropdown[];
    paymentMethodTypes: IDropdown[];
    daysOfWeek: IDropdown[];

    constructor(
        public settingsService: SettingsService,
        public authService: AuthService,
        public addLotService: AddLotService,
        private toastr: ToastrService,
        private router: Router
    ) {
        this.parking.Scheduler = new Array<Scheduler>();
        this.parking.Tariffs = new Array<RegisterTariff>();
        this.parking.LotGenerationList = new Array<RegisterParkingLot>();
        this.parking.HasSensors = false;
        this.parking.SensorLotList = [];
        this.parking.NoLots = 0;
        this.loading = false;

        this.parkingTypes = [
            { text: 'Stradala', id: Enums.eParkingType.Public },
            { text: 'Privata', id: Enums.eParkingType.Private }
        ];

        this.parkingLevelTypes = [
            { text: 'Subteran', id: Enums.eParkingLevel.Underground },
            { text: 'Suprafata', id: Enums.eParkingLevel.Surface },
            { text: 'Etajata', id: Enums.eParkingLevel.Multilevel }
        ];

        this.currencyTypes = [
            { text: 'RON', id: Enums.eCurrencyType.RON },
            { text: 'EUR', id: Enums.eCurrencyType.EUR }
        ];

        this.paymentMethodTypes = [
            { text: 'SMS', id: Enums.ePaymentMethodType.SMS },
            { text: 'Card', id: Enums.ePaymentMethodType.Card }
        ];

        this.daysOfWeek = [
            { text: 'Luni', id: Enums.eDayOfWeek.Monday },
            { text: 'Marti', id: Enums.eDayOfWeek.Tuesday },
            { text: 'Miercuri', id: Enums.eDayOfWeek.Wednesday },
            { text: 'Joi', id: Enums.eDayOfWeek.Thursday },
            { text: 'Vineri', id: Enums.eDayOfWeek.Friday },
            { text: 'Sambata', id: Enums.eDayOfWeek.Saturday },
            { text: 'Duminica', id: Enums.eDayOfWeek.Sunday }
        ];
    }

    ngOnInit(): void {
        this.user = this.authService.loadUserData();
    }

    submitForm(): void {
        if (this.user.company != null) {
            this.parking.CompanyID = this.user.company;
        } else if (this.user.publicInstitution != null) {
            this.parking.PublicInstitutionID = this.user.publicInstitution;
        }

        this.loading = true;

        this.addLotService.addParking(this.parking).subscribe(res => {
            this.toastr.success('Parking lot successfully added.');
            this.router.navigateByUrl('parking-lots');
            this.loading = false;
            // this.uploadImage(res, event);
        }, err => {
            this.toastr.error('A error has occurred while adding the parking lot.');
            this.loading = false;
        });
    }

    selectParkingType(value: IDropdown): void {
        this.parking.ParkingTypeID = value.id;
    }

    selectParkingLevelType(value: IDropdown): void {
        this.parking.ParkingLevelID = value.id;
    }

    //#region tariff methods
    selectTariff(tariff: RegisterTariff): void {
        this.currentTariff = { ...tariff };
    }

    newTariff(): void {
        this.currentTariff = new RegisterTariff();
    }

    selectTariffCurrency(tariff: RegisterTariff, value: IDropdown): void {
        tariff.CurrencyID = value.id;
    }

    selectPaymentMethodType(tariff: RegisterTariff, value: IDropdown): void {
        tariff.PaymentMethodTypeID = value.id;
    }

    selectStartWeekDay(tariff: RegisterTariff, value: IDropdown): void {
        tariff.StartWeekDay = value.id;
    }

    selectEndWeekDay(tariff: RegisterTariff, value: IDropdown): void {
        tariff.EndWeekDay = value.id;
    }

    saveTariff(): void {
        // verify if already exists
        if (this.currentTariff.id === 0) {
            this.id++;

            this.currentTariff.id = this.id;
            this.currentTariff.IsSaved = true;
            this.parking.Tariffs.push(this.currentTariff);
        } else {
            const index = this.parking.Tariffs.findIndex(t => t.id === this.currentTariff.id);
            this.parking.Tariffs[index] = { ...this.currentTariff };
        }

        this.currentTariff = null;
    }

    cancelTariffEditing(): void {
        this.currentTariff = null;
    }

    removeTariff(): void {
        const index = this.parking.Tariffs.findIndex(t => t.id === this.currentTariff.id);
        this.parking.Tariffs.splice(index, 1);
        this.currentTariff = null;
    }

    getTariffCurrency(value: number) {
        return this.settingsService.CURRENCY_TYPES(value);
    }
    //#endregion

    //#region scheduler methods
    onSelectDay(day: number) {
        const findIndex = this.parking.Scheduler.findIndex(item => item.DayOfWeek === day);
        if (findIndex === -1) {
            const _schedulers = new Array<Scheduler>();
            this.parking.Scheduler.forEach(item => {
                const newScheduler = new Scheduler();
                newScheduler.fromObject(item);

                _schedulers.push(newScheduler);
            });
            if (day == null) {
                _schedulers.forEach((item) => {
                    if (item.DayOfWeek != null) {
                        const index = this.parking.Scheduler.findIndex(sc => sc.DayOfWeek === item.DayOfWeek);
                        this.parking.Scheduler.splice(findIndex, 1);
                    }
                });
            } else if (day != null) {
                _schedulers.forEach((item, index) => {
                    // console.log(item);
                    if (item.DayOfWeek == null) {
                        this.parking.Scheduler.splice(index, 1);
                    }
                });
            }

            const scheduler = new Scheduler();

            scheduler.DayOfWeek = day;
            scheduler.Day = this.settingsService.DAY_OF_WEEK_BY_ID(day);

            if (day == null) {
                scheduler.SchedulerTypeID = Enums.eSchedulerType.Standard;
            } else {
                scheduler.SchedulerTypeID = Enums.eSchedulerType.Daily;
            }

            this.parking.Scheduler.push(scheduler);
        } else {
            this.parking.Scheduler.splice(findIndex, 1);
        }

        this.parking.Scheduler.sort((a, b) => {
            if (a.DayOfWeek < b.DayOfWeek) {
                return -1;
            } else if (a.DayOfWeek > b.DayOfWeek) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    isDaySelected(day: number) {
        const findIndex = this.parking.Scheduler.findIndex(item => item.DayOfWeek === day);
        if (findIndex === -1) {
            return false;
        } else {
            return true;
        }
    }

    getFirstLetter(day: number) {
        switch (day) {
            case null:
                return 'L - D';
            case Enums.eDayOfWeek.Monday:
                return 'L';
            case Enums.eDayOfWeek.Tuesday:
                return 'M';
            case Enums.eDayOfWeek.Wednesday:
                return 'M';
            case Enums.eDayOfWeek.Thursday:
                return 'J';
            case Enums.eDayOfWeek.Friday:
                return 'V';
            case Enums.eDayOfWeek.Saturday:
                return 'S';
            case Enums.eDayOfWeek.Sunday:
                return 'D';
        }
    }
    //#endregion

    //#region lot generation
    newLotGeneraion(): void {
        this.currentLotGeneration = new RegisterParkingLot();
    }

    saveLotGeneration(): void {
        if (this.currentLotGeneration.id === 0) {
            this.id++;

            this.currentLotGeneration.id = this.id;
            this.currentLotGeneration.IsSaved = true;
            this.parking.LotGenerationList.push(this.currentLotGeneration);
        } else {
            const index = this.parking.LotGenerationList.findIndex(t => t.id === this.currentLotGeneration.id);
            this.parking.NoLots -= this.parking.LotGenerationList[index].End - this.parking.LotGenerationList[index].Start + 1;
            this.parking.LotGenerationList[index] = { ...this.currentLotGeneration };
        }

        this.parking.NoLots += this.currentLotGeneration.End - this.currentLotGeneration.Start + 1;
        this.currentLotGeneration = null;
    }

    cancelLotGenerationEditing(): void {
        this.currentLotGeneration = null;
    }

    removeLotGeneration(): void {
        const index = this.parking.LotGenerationList.findIndex(t => t.id === this.currentLotGeneration.id);
        this.parking.NoLots -= this.parking.LotGenerationList[index].End - this.parking.LotGenerationList[index].Start + 1;
        this.parking.LotGenerationList.splice(index, 1);
        this.currentLotGeneration = null;
    }

    selectLotGeneration(value: RegisterParkingLot): void {
        this.currentLotGeneration = { ...value };
    }
    //#endregion

    cancel(): void {
        this.router.navigateByUrl('parking-lots');
    }
}
